import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajshtanbustrippackage() {



  const cardData =
  {
    keyword: 'Pune to Rajasthan Bus Trip Package ',
    heading: 'Sanavi Travels: Pune to Rajasthan Bus Trip Package',
    headingDescription: 'Sanavi Travels offers reliable Pune to Rajasthan Bus Trip Package, providing safe, comfortable, and well-organized long-distance travel solutions for families, tourist groups, corporate outings, educational tours, and cultural travelers planning a memorable journey from Pune to Rajasthan. Our fleet of luxury AC and Non-AC buses ranging from 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with push-back seating, ample legroom, and spacious luggage capacity to ensure a relaxed interstate travel experience. With experienced long-route drivers, customized multi-day tour packages, transparent pricing, and dedicated trip coordination, Sanavi Travels ensures a smooth and punctual Rajasthan tour. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering major Rajasthan destinations such as Jaipur, Udaipur, Jodhpur, Jaisalmer, Mount Abu, Ajmer, Pushkar, Bikaner, and Ranthambore. Choose Sanavi Travels for a dependable Pune to Rajasthan bus trip package, delivering comfort, safety, and an unforgettable royal travel experience.',

    top: 'Top Places to Visit in Rajasthan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Jaipur – The Pink City",
    "description": "Jaipur, the capital of Rajasthan, is famously known as the Pink City due to its rose-colored architecture. It is home to iconic landmarks like Hawa Mahal, City Palace, Amber Fort, and Jantar Mantar. The city beautifully blends royal heritage with vibrant bazaars and Rajasthani culture. Jaipur stands as the cultural and historical gateway to Rajasthan."
  },
  {
    "title": "Udaipur – City of Lakes",
    "description": "Udaipur is one of Rajasthan’s most romantic cities, known for its serene lakes, palaces, and scenic beauty. Attractions like City Palace, Lake Pichola, Jag Mandir, and Fateh Sagar Lake reflect royal elegance. The city’s white architecture and calm ambiance make it a favorite among honeymooners and heritage travelers. Udaipur symbolizes royal luxury and timeless beauty."
  },
  {
    "title": "Jaisalmer – The Golden City",
    "description": "Jaisalmer rises from the heart of the Thar Desert with its golden sandstone architecture. The majestic Jaisalmer Fort, Patwon Ki Haveli, and Sam Sand Dunes are major attractions. Camel safaris, desert camps, and folk performances offer an authentic desert experience. Jaisalmer showcases Rajasthan’s desert heritage and vibrant traditions."
  },
  {
    "title": "Jodhpur – The Blue City",
    "description": "Jodhpur is known for its blue-painted houses and the imposing Mehrangarh Fort. The fort offers panoramic views of the city and houses royal palaces and museums. Attractions like Jaswant Thada and Umaid Bhawan Palace add to its grandeur. Jodhpur reflects Rajasthan’s warrior history and architectural brilliance."
  },
  {
    "title": "Mount Abu",
    "description": "Mount Abu is Rajasthan’s only hill station, offering a cool climate and lush green landscapes. It is home to the famous Dilwara Jain Temples, Nakki Lake, and Guru Shikhar. The town provides a refreshing contrast to the desert terrain. Mount Abu blends spirituality, nature, and leisure."
  },
  {
    "title": "Pushkar",
    "description": "Pushkar is one of the oldest sacred towns in India, centered around the holy Pushkar Lake. It is famous for the Brahma Temple, one of the few temples dedicated to Lord Brahma. The annual Pushkar Camel Fair attracts tourists from around the world. Pushkar represents spirituality, tradition, and vibrant cultural festivities."
  },
  {
    "title": "Ajmer",
    "description": "Ajmer is a major pilgrimage city known for the Ajmer Sharif Dargah of Khwaja Moinuddin Chishti. Devotees of all faiths visit the shrine seeking blessings and peace. The city also features Ana Sagar Lake and historical structures. Ajmer symbolizes communal harmony and spiritual devotion."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort is the largest fort in India and a symbol of Rajput bravery and sacrifice. The fort complex includes Vijay Stambh, Kirti Stambh, and ancient palaces. It narrates tales of valor, jauhar, and heroic resistance. Chittorgarh stands as a powerful emblem of Rajasthan’s warrior spirit."
  },
  {
    "title": "Bikaner",
    "description": "Bikaner is known for its rich heritage, desert landscapes, and delicious snacks like bhujia. Junagarh Fort, Lalgarh Palace, and the Karni Mata Temple are major attractions. The city offers an authentic taste of Rajasthani culture and architecture. Bikaner blends royal history with desert charm."
  },
  {
    "title": "Ranthambore National Park",
    "description": "Ranthambore National Park is one of India’s most famous wildlife reserves, known for its Bengal tigers. The park features diverse flora, lakes, and the historic Ranthambore Fort within its boundaries. Safari experiences offer thrilling wildlife sightings. Ranthambore adds natural wilderness to Rajasthan’s royal landscape."
  }
]
,





"services": [
    {
      "name": "Pune to Rajasthan Bus Trip Package",
      "description": "Pune to Rajasthan Bus Trip Package offers comfortable and well-organized bus travel for exploring Rajasthan’s famous cities and heritage destinations. Ideal for families, groups, and tourists, this package ensures spacious seating, safe travel, and professional drivers for a smooth long-distance journey from Pune to Rajasthan."
    },
    {
      "name": "Rajasthan Tour Bus from Pune",
      "description": "Rajasthan Tour Bus from Pune provides reliable bus services for sightseeing and multi-city tours across Rajasthan. Well-maintained buses and experienced chauffeurs ensure a comfortable, safe, and enjoyable travel experience for tourists visiting historical and cultural attractions."
    },
    {
      "name": "AC Bus Pune to Rajasthan",
      "description": "AC Bus Pune to Rajasthan offers air-conditioned buses for a relaxed and comfortable long-distance journey. Suitable for family vacations and group tours, these buses provide spacious interiors, luggage space, and professional drivers for stress-free travel."
    },
    {
      "name": "Luxury Bus Rajasthan Tour",
      "description": "Luxury Bus Rajasthan Tour provides premium buses with comfortable interiors and modern amenities for an enhanced travel experience. Ideal for luxury holidays, corporate groups, or special tours, this service combines comfort, safety, and elegance throughout the Rajasthan trip."
    },
    {
      "name": "Family Rajasthan Bus Tour",
      "description": "Family Rajasthan Bus Tour is designed for families traveling together to explore Rajasthan. Spacious seating, smooth travel, and professional drivers ensure a safe and enjoyable holiday experience for all age groups."
    },
    {
      "name": "Group Travel Rajasthan Bus",
      "description": "Group Travel Rajasthan Bus caters to large groups, tour operators, and organizations planning Rajasthan trips. Comfortable buses and skilled drivers ensure coordinated travel, punctual schedules, and a smooth group touring experience."
    },
    {
      "name": "Affordable Rajasthan Bus Package",
      "description": "Affordable Rajasthan Bus Package offers budget-friendly tour options without compromising comfort or safety. Ideal for cost-conscious travelers, this service provides reliable buses, experienced drivers, and transparent pricing for Rajasthan tours."
    },
    {
      "name": "Chauffeur Driven Rajasthan Bus",
      "description": "Chauffeur Driven Rajasthan Bus provides experienced drivers familiar with long-distance routes and tourist destinations. Passengers can relax and enjoy the journey while ensuring safe, punctual, and hassle-free travel throughout Rajasthan."
    },
    {
      "name": "Best Rajasthan Tour Bus Pune",
      "description": "Best Rajasthan Tour Bus Pune offers top-quality buses and professional service for a superior travel experience. Known for comfort, reliability, and disciplined scheduling, this service is ideal for families, groups, and tourists traveling from Pune."
    },
    {
      "name": "Pune Rajasthan Travel Bus",
      "description": "Pune Rajasthan Travel Bus provides dependable long-distance transport between Pune and Rajasthan. Spacious seating, luggage-friendly interiors, and skilled drivers ensure a smooth and comfortable journey for all travelers."
    },
    {
      "name": "Tourist Bus Hire Rajasthan",
      "description": "Tourist Bus Hire Rajasthan offers buses for sightseeing and city tours across Rajasthan. Ideal for visiting forts, palaces, and heritage sites, these buses provide comfort, safety, and professional service for tourists."
    },
    {
      "name": "Long Distance Bus Tour Pune",
      "description": "Long Distance Bus Tour Pune specializes in extended journeys from Pune to destinations like Rajasthan. Comfortable buses, professional chauffeurs, and well-planned routes ensure a relaxed and enjoyable long-distance travel experience."
    },
    {
      "name": "Heritage Tour Bus Rajasthan",
      "description": "Heritage Tour Bus Rajasthan provides buses for exploring Rajasthan’s rich cultural and historical heritage. Suitable for tourists and groups, this service ensures comfortable travel between iconic heritage locations."
    },
    {
      "name": "Holiday Bus Package Pune",
      "description": "Holiday Bus Package Pune offers organized bus tours for vacations and holiday travel to Rajasthan. Designed for comfort and convenience, this service is ideal for families, friends, and group holiday planners."
    },
    {
      "name": "Rajasthan Trip Bus Service",
      "description": "Rajasthan Trip Bus Service provides reliable and comfortable buses for complete Rajasthan tours. With professional drivers, spacious seating, and efficient planning, this service ensures a smooth, safe, and memorable travel experience."
    }
  ],
  "tableData": [
    ["Pune to Rajasthan Bus Trip Package", "Rajasthan Tour Bus from Pune"],
    ["AC Bus Pune to Rajasthan", "Luxury Bus Rajasthan Tour"],
    ["Family Rajasthan Bus Tour", "Group Travel Rajasthan Bus"],
    ["Affordable Rajasthan Bus Package", "Chauffeur Driven Rajasthan Bus"],
    ["Best Rajasthan Tour Bus Pune", "Pune Rajasthan Travel Bus"],
    ["Tourist Bus Hire Rajasthan", "Long Distance Bus Tour Pune"],
    ["Heritage Tour Bus Rajasthan", "Holiday Bus Package Pune"],
    ["Rajasthan Trip Bus Service", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Rajasthan Bus Trip Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus trip packages from Pune to Rajasthan, perfect for group tours, family trips, and long-distance sightseeing journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with comfortable seating and ample legroom for a smooth journey from Pune to Rajasthan."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune, Rajasthan, and highway routes, ensuring safe, timely, and hassle-free long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear pricing for Pune to Rajasthan bus packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, itinerary planning, and travel inquiries for your Rajasthan trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus trip packages according to your travel schedule and group requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene during the long journey."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Rajasthan bus trips."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer bus trip packages from Pune to Rajasthan?',
    answer: 'Yes, Sanavi Travels provides well-organized and comfortable bus packages for travel from Pune to Rajasthan.'
  },
  {
    question: 'How can I book a Pune to Rajasthan bus package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Rajasthan trip?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for long-distance group travel.'
  },
  {
    question: 'Are drivers included in the bus trip package?',
    answer: 'Yes, all packages include experienced and professional drivers familiar with the Pune-Rajasthan routes.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey to ensure passenger safety.'
  },
  {
    question: 'Can I customize the Pune to Rajasthan bus trip package?',
    answer: 'Absolutely. Sanavi Travels offers customized packages according to your travel and group requirements.'
  },
  {
    question: 'What payment options are available for the bus package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Rajasthan journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Booked the Pune to Rajasthan bus trip package with Sanavi Travels. Very comfortable and well-organized. Excellent driver and service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Deshmukh',
    feedback: 'Amazing experience! The bus was spacious, clean, and on-time. Highly recommend Sanavi Travels for long-distance trips.',
    rating: 5
  }
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Bus Trip Package - Sanavi Travels",
  "description": "Pune to Rajasthan bus trip package by Sanavi Travels for family trips, group travel, and heritage tours. Choose AC and luxury buses for safe, comfortable, and affordable long-distance travel from Pune to Rajasthan.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1650"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Rajasthan Bus Trip Package Starting from ₹55 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Rajasthan bus trip packages with Sanavi Travels. AC and luxury buses for family trips, group travel, and heritage tours at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetorajshtanbustrippackage;